export default {
  REELS_COUNT: 7,
  ELEMENTS_COUNT: 12
}
